import { FC } from 'react';

import PlatformListing from 'components/main/Reports/Platform';

const Platform: FC = () => <PlatformListing />;

export default Platform;
